import e from "./index35.js";
import t from "./index39.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/palette/palette.js
function n(e, t) {
	return t === "grey" ? t : e;
}
t(e({
	prop: "color",
	themeKey: "palette",
	transform: n
}), e({
	prop: "bgcolor",
	cssProperty: "backgroundColor",
	themeKey: "palette",
	transform: n
}), e({
	prop: "backgroundColor",
	themeKey: "palette",
	transform: n
}));
//#endregion
export { n as paletteTransform };

//# sourceMappingURL=index42.js.map